// PostgREST cắt MỌI response ở db-max-rows (~1000 dòng) bất kể .limit() → bảng lớn
// hơn phải đọc theo lô .range(). Đọc 1 phát là THIẾU dòng mà không báo lỗi gì — đã
// gặp ở tồn kho, đếm đơn, và 06/10/2026 ở bảng customers (1.724 khách → ~700 khách cũ
// biến mất, đơn hiện "KH #id").
export const POSTGREST_MAX_ROWS = 1_000

// `page(from, to)` phải dựng query MỚI cho từng lô (builder supabase-js chỉ chạy được
// 1 lần) và có ORDER ổn định, không thì các lô chồng/hụt dòng. Lô trả ÍT hơn pageSize
// = hết bảng → pageSize phải ≤ db-max-rows, không thì lô đầy bị cắt ngắn và vòng lặp
// tưởng đã đọc xong. `maxRows` = trần CHỦ ĐÍCH của caller (vd file xuất tối đa 10.000
// dòng): đủ trần thì dừng, không đọc thừa.
export async function fetchAllPages<T>(
  page: (from: number, to: number) => PromiseLike<{ data: unknown; error: unknown }>,
  pageSize: number = POSTGREST_MAX_ROWS,
  maxRows: number = Number.POSITIVE_INFINITY,
): Promise<T[]> {
  const rows: T[] = []
  for (let from = 0; from < maxRows; from += pageSize) {
    const to = Math.min(from + pageSize, maxRows) - 1
    const { data, error } = await page(from, to)
    if (error) throw error
    const batch = (data ?? []) as T[]
    rows.push(...batch)
    if (batch.length < to - from + 1) return rows
  }
  return rows
}
